import { IDashboardFilter } from "api/interfaces";
import { RequiredParamException } from "../exceptions/InvalidParamException";
import UserModel from "../models/UserModel";
import UserRepository from "../repositories/UserRepository";

class UserService {
  addUser(user: UserModel) {
    return UserRepository.addUserOfAuthentication(user.uid, user);
  }

  getUsersByEmail(emails: string[]): Promise<UserModel[]> {
    return UserRepository.getUsersFromDataBaseByEmail(emails);
  }

  getUsersByUid(uids: string[]): Promise<UserModel[]> {
    return UserRepository.getAllUsersFromDataBaseByUid(uids);
  }

  public getUsersByRoleUid(roleUid: string): Promise<UserModel[]> {
    return UserRepository.getUsersFromDataBaseByRoleId(roleUid);
  }

  getUserByUid(uid: string): Promise<UserModel> {
    return UserRepository.getUserFromDataBaseByUid(uid);
  }

  updateUserStatus(user: Object): Promise<void> {
    return UserRepository.updateStatus(user);
  }

  public async updateUserRole(user: UserModel, roleId: string): Promise<void> {
    await UserRepository.updateUserOnDataBase(user.uid, {
      roleId: roleId || "",
    });
    user.setRoleId(roleId);
  }

  public async updateContractStatusFiltered(
    user: UserModel,
    status: string[]
  ): Promise<void> {
    await UserRepository.updateUserOnDataBase(user.uid, {
      contractStatusFiltered: status || [],
    });
    user.setContractStatusFiltered(status);
  }

  public async updateDashboardFilters(
    user: UserModel,
    filters: IDashboardFilter
  ): Promise<void> {
    await UserRepository.updateUserOnDataBase(user.uid, {
      dashboardFilters: filters ? { ...filters } : undefined,
    });
    user.setDashboardFilters(filters);
  }

  deleteUser(user: object): Promise<void> {
    return UserRepository.deleteUser(user);
  }

  createAcount(user: object): Promise<any> {
    return UserRepository.createAcount(user);
  }
  updateProfile(user: UserModel) {
    if (!user.name) throw new RequiredParamException("name");
    return UserRepository.updateUserProfile(user.uid, user.name, user.photoURL);
  }

  async updateEmail(user: UserModel, email: string) {
    if (!user.email) throw new RequiredParamException("email");

    return UserRepository.updateUserOnDataBase(user.uid, {
      email,
      emailVerified: false,
    });
  }

  // Atualiza o token para deslogar o usuario em outras sessoes
  async updateSessionData(user: UserModel, token: string) {
    const lastSignInTime = user.lastSignInTime;
    const lastSignOnFaturamento = { token, lastSignInTime };

    if (token) {
      await UserRepository.updateUserOnDataBase(user.uid, {
        token,
        lastSignInTime,
        lastSignOnFaturamento,
      });
    }
  }
}

export default new UserService();
